import { c as _c } from "react/compiler-runtime";
// Шевроны и стрелки из Figma «OSMIX ЛК Покупателя» (cHkTZXVaiia41bQ9HlRF7O),
// выгрузка SVG 02.10.2026. Цвет — currentColor (задаётся text-*), размер — проп size.
// Файл собран скриптом из audit/DS/icons-svg: правьте рисунок там и пересобирайте.
import { type IconProps, Svg } from "./icon";

/** Шеврон вниз 20: город в шапке, выпадающие списки. Figma: «chevron-down / Size=M · 20». */
export function ChevronDown20Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 20 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M4.41009 6.91107C4.73553 6.58563 5.26317 6.58563 5.5886 6.91107L9.99935 11.3218L14.4101 6.91107C14.7355 6.58563 15.2632 6.58563 15.5886 6.91107C15.914 7.23651 15.914 7.76414 15.5886 8.08958L10.5886 13.0896C10.4323 13.2459 10.2204 13.3337 9.99935 13.3337C9.77834 13.3337 9.56637 13.2459 9.41009 13.0896L4.41009 8.08958C4.08466 7.76414 4.08466 7.23651 4.41009 6.91107Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Шеврон вниз 16: кнопки «Выбрать размер», «Мои заказы». Figma: «chevron-down / Size=S · 16». */
export function ChevronDown16Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M3.52729 5.52827C3.78764 5.26792 4.20975 5.26792 4.4701 5.52827L7.9987 9.05687L11.5273 5.52827C11.7876 5.26792 12.2098 5.26792 12.4701 5.52827C12.7305 5.78862 12.7305 6.21073 12.4701 6.47108L8.4701 10.4711C8.34508 10.5961 8.17551 10.6663 7.9987 10.6663C7.82189 10.6663 7.65232 10.5961 7.52729 10.4711L3.52729 6.47108C3.26694 6.21073 3.26694 5.78862 3.52729 5.52827Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 16 16" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Шеврон вниз 24: FAQ поддержки. Figma: «Chevron / State=Default, direction=Down». */
export function ChevronDownIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16C11.7348 16 11.4804 15.8946 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Шеврон вверх 24: FAQ поддержки. Figma: «Chevron / State=Default, direction=Up». */
export function ChevronUpIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M11.2929 8.29289C11.6834 7.90237 12.3166 7.90237 12.7071 8.29289L18.7071 14.2929C19.0976 14.6834 19.0976 15.3166 18.7071 15.7071C18.3166 16.0976 17.6834 16.0976 17.2929 15.7071L12 10.4142L6.70711 15.7071C6.31658 16.0976 5.68342 16.0976 5.29289 15.7071C4.90237 15.3166 4.90237 14.6834 5.29289 14.2929L11.2929 8.29289Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Шеврон вверх 20: раскрытый фильтр. Figma: «chevron-up / Size=M · 20». */
export function ChevronUp20Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 20 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M9.41205 6.91107C9.73748 6.58563 10.2651 6.58563 10.5906 6.91107L15.5906 11.9111C15.916 12.2365 15.916 12.7641 15.5906 13.0896C15.2651 13.415 14.7375 13.415 14.412 13.0896L10.0013 8.67884L5.59056 13.0896C5.26512 13.415 4.73748 13.415 4.41205 13.0896C4.08661 12.7641 4.08661 12.2365 4.41205 11.9111L9.41205 6.91107Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Шеврон вверх 16: раскрытая кнопка размера. Figma: «chevron-up / Size=S · 16». */
export function ChevronUp16Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M7.52729 5.52827C7.78764 5.26792 8.20975 5.26792 8.4701 5.52827L12.4701 9.52827C12.7305 9.78862 12.7305 10.2107 12.4701 10.4711C12.2098 10.7314 11.7876 10.7314 11.5273 10.4711L7.9987 6.94248L4.4701 10.4711C4.20975 10.7314 3.78764 10.7314 3.52729 10.4711C3.26694 10.2107 3.26694 9.78862 3.52729 9.52827L7.52729 5.52827Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 16 16" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Назад 24: крошки, шапки страниц. Figma: «chevron-left / Size=L · 24». */
export function ChevronLeftIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711L10.4142 12L15.7071 17.2929C16.0976 17.6834 16.0976 18.3166 15.7071 18.7071C15.3166 19.0976 14.6834 19.0976 14.2929 18.7071L8.29289 12.7071C8.10536 12.5196 8 12.2652 8 12C8 11.7348 8.10536 11.4804 8.29289 11.2929L14.2929 5.29289C14.6834 4.90237 15.3166 4.90237 15.7071 5.29289Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Назад 16: крошки быстрого просмотра. Figma: «chevron-left / Size=S · 16». */
export function ChevronLeft16Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M10.4727 3.52827C10.7331 3.78862 10.7331 4.21073 10.4727 4.47108L6.94411 7.99967L10.4727 11.5283C10.7331 11.7886 10.7331 12.2107 10.4727 12.4711C10.2124 12.7314 9.79025 12.7314 9.5299 12.4711L5.5299 8.47108C5.40487 8.34605 5.33464 8.17649 5.33464 7.99967C5.33464 7.82286 5.40487 7.65329 5.5299 7.52827L9.5299 3.52827C9.79025 3.26792 10.2124 3.26792 10.4727 3.52827Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 16 16" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Вперёд 24: листание фото. Figma: «chevron-right / Size=L · 24». */
export function ChevronRightIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C15.8946 11.4804 16 11.7348 16 12C16 12.2652 15.8946 12.5196 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Вперёд 20: заголовки подборок «Идеи OSMIX ›». Figma: «chevron-right / Size=M · 20». */
export function ChevronRight20Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 20 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M6.91205 4.41058C7.23748 4.08514 7.76512 4.08514 8.09056 4.41058L13.0906 9.41058C13.2468 9.56686 13.3346 9.77882 13.3346 9.99984C13.3346 10.2209 13.2468 10.4328 13.0906 10.5891L8.09056 15.5891C7.76512 15.9145 7.23748 15.9145 6.91205 15.5891C6.58661 15.2637 6.58661 14.736 6.91205 14.4106L11.3228 9.99984L6.91205 5.58909C6.58661 5.26366 6.58661 4.73602 6.91205 4.41058Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Вперёд 16: строки адресов, кнопки. Figma: «chevron-right / Size=S · 16». */
export function ChevronRight16Icon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M5.52729 3.52827C5.78764 3.26792 6.20975 3.26792 6.4701 3.52827L10.4701 7.52827C10.5951 7.65329 10.6654 7.82286 10.6654 7.99967C10.6654 8.17649 10.5951 8.34605 10.4701 8.47108L6.4701 12.4711C6.20975 12.7314 5.78764 12.7314 5.52729 12.4711C5.26694 12.2107 5.26694 11.7886 5.52729 11.5283L9.05589 7.99967L5.52729 4.47108C5.26694 4.21073 5.26694 3.78862 5.52729 3.52827Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 16 16" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Шеврон вниз (тонкий контур) 20: «Показать ещё». Figma: «Chevron down». */
export function ChevronDownStrokeIcon(t0) {
  const $ = _c(10);
  let props;
  let strokeWidth;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      strokeWidth,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = strokeWidth;
    $[3] = t1;
  } else {
    props = $[1];
    strokeWidth = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 20 : t1;
  const t2 = strokeWidth ?? 1.5;
  let t3;
  if ($[4] !== t2) {
    t3 = <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={t2} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== size || $[8] !== t3) {
    t4 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t3}</Svg>;
    $[6] = props;
    $[7] = size;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}

/** Шеврон вправо (тонкий контур) 24: строки оформления заказа. Figma: «Chevron right / Size=24». */
export function ChevronRightStrokeIcon(t0) {
  const $ = _c(10);
  let props;
  let strokeWidth;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      strokeWidth,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = strokeWidth;
    $[3] = t1;
  } else {
    props = $[1];
    strokeWidth = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  const t2 = strokeWidth ?? 1.5;
  let t3;
  if ($[4] !== t2) {
    t3 = <path d="M9 18L15 12L9 6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={t2} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== size || $[8] !== t3) {
    t4 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t3}</Svg>;
    $[6] = props;
    $[7] = size;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}

/** Стрелка назад 32: отзывы (мобильная шапка). Figma: «Arrow left / Size=32». */
export function ArrowLeftIcon(t0) {
  const $ = _c(10);
  let props;
  let strokeWidth;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      strokeWidth,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = strokeWidth;
    $[3] = t1;
  } else {
    props = $[1];
    strokeWidth = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 32 : t1;
  const t2 = strokeWidth ?? 1.5;
  let t3;
  if ($[4] !== t2) {
    t3 = <path d="M25.3346 16.0003H6.66797M16.0013 6.66699L6.66797 16.0003L16.0013 25.3337" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={t2} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== size || $[8] !== t3) {
    t4 = <Svg size={size} viewBox="0 0 32 32" {...props}>{t3}</Svg>;
    $[6] = props;
    $[7] = size;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}

/** Стрелка вправо залитая (лендинг продавца). Figma: «Bold/Arrow - Right». */
export function ArrowRightBoldIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M13.0586 6C13.4898 6.01443 14.393 6.3907 14.4014 6.40723C15.8654 7.02151 18.6897 8.87561 19.9941 10.1973L20.373 10.5938C20.4722 10.7012 20.5841 10.8286 20.6533 10.9277C20.8846 11.2339 21 11.6133 21 11.9922C21 12.415 20.8703 12.8083 20.625 13.1299L20.2354 13.5508L20.1484 13.6406C18.9648 14.9239 15.8735 17.0219 14.2568 17.6641L14.0127 17.7578C13.7191 17.863 13.308 17.9883 13.0586 18C12.7412 18 12.4375 17.9266 12.1484 17.7812C11.7874 17.5775 11.4991 17.2549 11.3398 16.876C11.2386 16.6139 11.0798 15.8304 11.0791 15.8125C10.9331 15.0184 10.8491 13.7648 10.8369 12.3604L10.835 12.0068C10.835 10.5352 10.921 9.19297 11.0508 8.31836L11.165 7.77441C11.2283 7.48651 11.3108 7.15857 11.3975 6.99121C11.7148 6.37891 12.3358 6.00018 13 6H13.0586ZM8.20215 10.8086C8.85341 10.8086 9.38184 11.3424 9.38184 12C9.3816 12.6585 8.85327 13.1904 8.20215 13.1904L4.50293 13.5176C3.67305 13.5174 3.00024 12.8379 3 12C3 11.1618 3.67291 10.4816 4.50293 10.4814L8.20215 10.8086Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}